import { IPetCreateRequest, IPetCreateResponse } from "./pet-create.interface";

import { DASHBOARD } from "../dashboard/dashboard.query";
import { GET_ALL_PETS } from "../pet-list/pet-list.query";
import { PET_CREATE } from "./pet-create.mutation";
import { PetFormType } from "./pet-create.schema";
import { mapToPetCreateRequest2 } from "./pet-create.mapper";
import { toastMessageActions } from "../../state/request";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useMutation } from "@apollo/client";

export const usePetCreate = () => {
  const dispatch = useDispatch();
  const [create, { data, loading, error }] = useMutation<{addAPetV2 :IPetCreateResponse}>(PET_CREATE, {
    refetchQueries: [
      { query: DASHBOARD },
      { query: GET_ALL_PETS },
    ],
    awaitRefetchQueries: true,
  });

  const addAPet = (dataForm:PetFormType, newPetImage:File) => {
    const petRequest: IPetCreateRequest = mapToPetCreateRequest2(dataForm);

    create({
      variables: {
        pet: petRequest,
        file: newPetImage || null,
      },
    });
  };

  useEffect(() => {
    dispatch(toastMessageActions.setGlobalLoading(loading));
  }, [loading]);

  useEffect(() => {
    if (data) {
      const petName = data?.addAPetV2?.pet?.name?.charAt(0)?.toUpperCase() + data?.addAPetV2?.pet?.name?.slice(1);

      dispatch(toastMessageActions.setGlobalAlert({
        severity: "success",
        message: `${petName} added successfully`,
      }));
    }
  }, [data]);

  return {
    petCreated: data?.addAPetV2,
    loading,
    error,
    addAPet,
  };
};
